export enum TypeControlEnum {
    GENERIC= 'GENERIC',
    EPP = 'EPP'
}
